export const defaultProjectResponsibleFields = [
  { field: 'expansionProjectEditors', label: 'labels.expansionProjectEditors' },
];
